import React from "react";
import Marquee from "react-fast-marquee";
import { SKILLS } from "../data/content";

/** Moving chip strip highlighting design prowess. */
export const SkillsMarquee = () => {
  return (
    <section className="py-8 border-y hairline overflow-hidden" data-testid="skills-marquee" style={{ background: "var(--surface)" }}>
      <Marquee speed={45} gradient={false} autoFill pauseOnHover>
        {SKILLS.map((s, i) => (
          <span key={i} className="skill-chip" data-testid={`skill-${i}`}>
            <span className="dot" />
            {s}
          </span>
        ))}
      </Marquee>
    </section>
  );
};

export default SkillsMarquee;
